<span [class]="hostClasses" [attr.title]="tooltip || null">
  <span class="status-badge__label">{{ label }}</span>
</span>
